import PassengerClassesNoLongerAvailableDataType
    from "@CheckOrder/features/modals/types/PassengerClassesNoLongerAvailableData.type";
import CheckOrderTicketType from "@CheckOrder/types/CheckOrderTicket.type";
import AvailablePassengerClassType from "@CheckOrder/features/classPicker/types/AvailablePassengerClass.type";

type SelectedPassengerClass = AvailablePassengerClassType & {
    assignedPassengersIds: number[],
    assignedPassengersGroupId: number
}

export default function handleNoLongerAvailablePassengerClasses(
    ticket: CheckOrderTicketType,
    selectedSingleClasses: SelectedPassengerClass[],
    selectedReturnClasses: SelectedPassengerClass[]
) {
    const {
        singleSelectedPassengerClasses: {
            noLongerAvailablePassengerClasses: singleNoLongerAvailablePassengerClasses,
        },
        returnSelectedPassengerClasses: {
            noLongerAvailablePassengerClasses: returnNoLongerAvailablePassengerClasses,
        },
    } = ticket
    const noLongerAvailablePassengerClassesData: PassengerClassesNoLongerAvailableDataType = {
        noLongerAvailableClasses: [],
        affectedPassengerIdsPerClass: {},
    }

    const findNoLongerAvailablePassengerClass = (selectedClasses: SelectedPassengerClass[], noLongerAvailableClassId: number) => (
        selectedClasses.find((selectedClass) => (
            selectedClass.id === noLongerAvailableClassId
        ))
    )

    if (singleNoLongerAvailablePassengerClasses.length) {
        singleNoLongerAvailablePassengerClasses.map((noLongerAvailableClassId) => {
            const noLongerAvailablePassengerClass = findNoLongerAvailablePassengerClass(
                selectedSingleClasses,
                noLongerAvailableClassId
            )

            noLongerAvailablePassengerClassesData.noLongerAvailableClasses.push(noLongerAvailablePassengerClass)

            noLongerAvailablePassengerClassesData.affectedPassengerIdsPerClass[noLongerAvailablePassengerClass.id] = [
                ...(noLongerAvailablePassengerClassesData.affectedPassengerIdsPerClass[noLongerAvailablePassengerClass.id] ?? []),
                ...noLongerAvailablePassengerClass.assignedPassengersIds,
            ]
        })
    }

    if (returnNoLongerAvailablePassengerClasses.length) {
        returnNoLongerAvailablePassengerClasses.map((noLongerAvailableClassId) => {
            const noLongerAvailablePassengerClass = findNoLongerAvailablePassengerClass(
                selectedReturnClasses,
                noLongerAvailableClassId
            )

            noLongerAvailablePassengerClassesData.noLongerAvailableClasses.push(noLongerAvailablePassengerClass)

            noLongerAvailablePassengerClassesData.affectedPassengerIdsPerClass[noLongerAvailablePassengerClass.id] = [
                ...(noLongerAvailablePassengerClassesData.affectedPassengerIdsPerClass[noLongerAvailablePassengerClass.id] ?? []),
                ...noLongerAvailablePassengerClass.assignedPassengersIds,
            ]
        })
    }

    return {
        noLongerAvailablePassengerClassesData,
    }
}